var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"landing-header"},[_c('div',{staticClass:"background-fill"}),_c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"autodesk-logo-parent",on:{"click":function($event){return _vm.navigateHome()}}},[_c('div',{staticClass:"autodesk-logo"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }